'use client';
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { useLegacyTrackPageView } from '@//data/tracking/useLegacyTrackPageView';

// Paths where page view tracking should be skipped
const SKIP_TRACKING_PATHS = ['/item/[[...id]]', '/objekt/[[...id]]'];

const TrackPageView = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { trackLegacyPageView } = useLegacyTrackPageView();

  useEffect(() => {
    // Skip tracking if current path matches any skip path
    const shouldSkip = SKIP_TRACKING_PATHS.some((skipPath) => {
      if (skipPath === pathname) return true;

      // Handle dynamic routes
      if (skipPath.includes('[')) {
        // Handle optional catch-all routes like [[...id]] - matches zero or more segments
        let pattern = skipPath.replace(/\[\[\.\.\.([^\]]+)\]\]/g, '(.*)');
        // Handle catch-all routes like [...id] - matches one or more segments
        pattern = pattern.replace(/\[\.\.\.([^\]]+)\]/g, '(.+)');
        // Handle regular dynamic routes like [id] - matches one segment
        pattern = pattern.replace(/\[([^\]]+)\]/g, '([^/]+)');
        const regex = new RegExp(`^${pattern}$`);
        return regex.test(pathname);
      }

      return false;
    });

    if (shouldSkip) {
      return;
    }

    trackLegacyPageView();
  }, [pathname, searchParams]);

  return null;
};

export default TrackPageView;
